import React from 'react';

const MistralAI = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Mistral AI launched out of Paris in May 2023 with a team of former DeepMind and Meta
      researchers, a $113 million seed round, and a very clear thesis: powerful AI models
      don't have to be closed. Their first public release, Mistral 7B, arrived in September
      2023 with no access form, no waitlist, just a magnet link. The AI community downloaded
      it hundreds of thousands of times. Two years later, Mistral has become the leading
      European AI company, and its models are used in millions of deployments worldwide.
    </p>

    <h2>The model lineup</h2>
    <p>
      Mistral's releases have been consistently punching above their weight in terms of
      performance-to-size ratio:
    </p>
    <ul>
      <li><strong>Mistral 7B (Sep 2023):</strong> Outperformed Llama 2 13B despite half the parameters</li>
      <li><strong>Mixtral 8x7B (Dec 2023):</strong> A "mixture of experts" model that activates only 2 of 8 expert networks per token - fast, efficient, strong on reasoning</li>
      <li><strong>Mistral Large (Feb 2024):</strong> Competitive with GPT-4 on several benchmarks</li>
      <li><strong>Codestral (May 2024):</strong> Specialised coding model, strong on completion and generation</li>
      <li><strong>Mistral 3 (early 2025):</strong> Their most capable model family, available both via API and as open weights</li>
    </ul>

    <h2>The open-source commitment</h2>
    <p>
      Unlike most AI companies who release open weights as a PR move while keeping the
      best models proprietary, Mistral has consistently released genuinely capable open
      models. Mixtral 8x7B and several other models are available under Apache 2.0,
      which allows commercial use, modification, and redistribution with few restrictions.
    </p>
    <p>
      This has made Mistral models the go-to choice for enterprises that need customisable,
      self-hostable AI without the licensing complexity of some other open models.
    </p>

    <h2>The European angle</h2>
    <p>
      Mistral is one of the most prominent examples of European AI ambition. With €600
      million raised and a valuation above $6 billion, it's proved that world-class AI
      research can happen outside Silicon Valley and Beijing.
    </p>
    <p>
      The EU AI Act, which came into force in 2024, created new obligations for "general
      purpose AI" providers. Mistral has engaged actively with EU policymakers and
      positioned itself as the compliant European alternative to US providers for
      organisations subject to EU data sovereignty requirements.
    </p>

    <h2>Le Chat - the consumer product</h2>
    <p>
      Beyond API and developer tools, Mistral launched Le Chat - a consumer AI assistant
      available for free. It reached one million users within days of its improved launch
      in early 2025. For Mistral, it's both a showcase for their models and a direct
      competitor to ChatGPT in European markets.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Mistral proved you can build a competitive AI company in Europe with a strong
        open-source ethos. Their success has been as much about product decisions - release
        openly, price fairly, integrate well - as about raw model performance. As European
        AI sovereignty becomes a policy priority, Mistral is well-positioned to be the
        infrastructure layer that EU organisations trust.
      </p>
    </div>
  </article>
);

export default MistralAI;
